import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation TransferChat($chatId: ID!, $targetId: ID) {
    transferChat(id: $chatId, targetId: $targetId) {
      id
      status
      createdAt
      transfer {
        id
        confirmedAt
      }
    }
  }
`);
